import { render, staticRenderFns } from "./CreateCourseLessonPopup.vue?vue&type=template&id=8e158752&scoped=true"
import script from "./CreateCourseLessonPopup.vue?vue&type=script&lang=js"
export * from "./CreateCourseLessonPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseLessonPopup.vue?vue&type=style&index=0&id=8e158752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e158752",
  null
  
)

export default component.exports